import {get, post} from '~/utils/request';

export function getMeCityList() { //取会员城市列表
  return get('/Common/CityBuy');
}

export function getPositionList() { //取职能列表
  return get('/Common/Position');
}

export function getIndustryList() { //取行业列表
  return get('/Common/Industry');
}

export function getCoTypeList() {   //取公司性质列表
  return get('/Common/CompanyType');
}

export function certificateList() { //取证书列表
  return get('/Common/CertificateLibarary');
}

export function languageSkillList() { //取语言能力列表
  return get('/Common/LanguageSkillLibarary');
}

export function skillLevelList() {  //取技能熟练程度列表
  return get('/Common/SkillLevel');
}

export function addPageVisit() {  //添加页面访问记录
  return get('/PageVisit/Add');
}

export function getSplitWords(data) {  //分词
  return post('/Common/GetSplitWords',data);
}

export function highlightWord(text, words){//高亮关键词
  words.forEach(word => {
    text = text.replace(word, `<em style='color:#dd3d42;'>${word}</em>`);
  });
  return text;
}
